var _g, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownvoteFailed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 27,
    viewBox: "0 0 35 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.4199 17.9691L27.3636 17.9691C28.5058 17.9691 29.4242 17.0501 29.4242 15.9071L29.4242 2.35691C29.4242 1.22576 28.5058 0.294923 27.3636 0.294923L24.4199 0.294922C23.2778 0.294922 22.3594 1.22576 22.3594 2.35691L22.3594 15.9071C22.3594 17.0501 23.2778 17.9691 24.4199 17.9691Z",
    fill: "#FF892A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.70857 17.0851L10.2662 17.0851C10.2662 17.0851 9.38313 18.8525 9.38313 21.7982C9.38313 25.333 12.0324 26.5113 13.2099 26.5113C14.3874 26.5113 14.9761 25.9222 14.9761 22.9765C14.9761 20.0308 17.6843 17.9216 19.427 16.7669L19.427 2.16804C17.543 1.29611 13.7633 2.40646e-06 7.91129 1.38325e-06L6.02734 1.05385e-06C3.73127 6.52396e-07 1.77667 1.64959 1.3881 3.91189L0.0693345 11.5707C-0.425204 14.4575 1.78844 17.0851 4.70857 17.0851Z",
    fill: "#FF892A"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 25C32.3137 25 35 22.3137 35 19C35 15.6863 32.3137 13 29 13C25.6863 13 23 15.6863 23 19C23 22.3137 25.6863 25 29 25Z",
    fill: "#52ACBC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.1503 20.4355C25.7598 20.8261 25.7598 21.4592 26.1503 21.8498C26.5408 22.2403 27.174 22.2403 27.5645 21.8498L29.0003 20.414L30.436 21.8498C30.8266 22.2403 31.4597 22.2403 31.8502 21.8498C32.2408 21.4592 32.2408 20.8261 31.8502 20.4355L30.4145 18.9998L31.8502 17.564C32.2408 17.1735 32.2408 16.5404 31.8502 16.1498C31.4597 15.7593 30.8266 15.7593 30.436 16.1498L29.0003 17.5856L27.5645 16.1498C27.174 15.7593 26.5408 15.7593 26.1503 16.1498C25.7598 16.5404 25.7598 17.1735 26.1503 17.564L27.5861 18.9998L26.1503 20.4355Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownvoteFailed);
export default __webpack_public_path__ + "static/media/downvote-failed.12dbfce348d27be1490d758c918d3b75.svg";
export { ForwardRef as ReactComponent };